export default __webpack_public_path__ + "static/media/Snd4.11c8e622.mp3";